import { Splide } from '@splidejs/splide';

const defaultSliderOptions = {
    type: 'loop',
    perPage: 1,
    classes: {
        pagination: 'splide__pagination sw-slider-pagination',
        page: 'splide__pagination__page sw-slider-page'
    }
};
// TODO: use ui slider
export default function (options = {}) {
    const { onlyMobile = false, ...splideOptions } = options;

    return {
        onlyMobile,
        options: {
            ...defaultSliderOptions,
            ...splideOptions
        },
        slider: null,

        init() {
            this.setupWatchers();

            if (this.onlyMobile && !this.isMobile()) {
                return;
            }

            this.mount();
        },

        setupWatchers() {
            this.$watch('isMobile()', (val) => {
                if (!this.onlyMobile) return;

                if (val && !this.slider) this.mount();

                if (!val) this.destroy();
            });

            this.$watch('$store.mq.minWidth', () => {
                this.slider && this.slider.go(0);
            });
        },

        isMobile() {
            return this.$store.mq.isMobile();
        },

        mount() {
            if (this.slider) {
                this.slider.mount();
                return;
            }

            this.$nextTick(() => {
                this.slider = new Splide(
                    this.$el.querySelector('.splide'),
                    this.options
                ).mount();
                this.setupSliderEvents();
            });
        },

        destroy() {
            if (!this.slider) return;

            this.slider.destroy();
            this.slider = null;
        },

        setupSliderEvents() {
            this.slider.on('resized', () => {
                this.slider && this.slider.go(0);
            });
        }
    };
}
